import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import cx from 'classnames';

import RawImageInput from '../../ImageInput';

import FieldWrapper from './FieldWrapper';

import { imageInput } from '../styles.module.css';

const ImageInput = (props) => {
  const { id, validation, required, title, multiple } = props;
  const { setValue, getValues } = useFormContext();
  const { className } = props;
  const setImageData = (imageData) => setValue(id, imageData);
  const deleteImage = (index) => {
    const removeEl = (a) => a.slice(0, index).concat(a.slice(index + 1));
    const { images, files } = getValues()[id];

    setImageData({ images: removeEl(images), files: removeEl(files) });
  };

  return (
    <FieldWrapper {...props}>
      <Controller
        name={id}
        multiple={multiple}
        rules={{
          required: required && `${title} required`,
          ...validation,
        }}
        className={cx(className, imageInput)}
        onImageUploadInputClick={() => {
          // # TODO tracking function
        }}
        onImageUpload={setImageData}
        onThumbnailClick={deleteImage}
        imageObjectFit="contain"
        discriminator={id}
        as={(inputProps) => (
          <RawImageInput
            {...inputProps}
            images={inputProps?.value?.images || []}
          />
        )}
      />
    </FieldWrapper>
  );
};

export default ImageInput;
